export default function FrameRail({
  frames,
  current,
  onSelect,
  onMove,
  onDuplicate,
  onBlank,
  onDelete,
}) {
  return (
    <div
      style={{
        width: 196,
        flex: 'none',
        borderRight: '1px solid var(--color-neutral-300)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 10,
          letterSpacing: 3,
          color: 'var(--color-neutral-600)',
          padding: '12px 14px 6px',
        }}
      >
        FRAMES
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6, padding: '6px 12px' }}>
        {frames.map((fr, k) => {
          const on = k === current
          return (
            <div
              key={k}
              onClick={() => onSelect(k)}
              style={{
                display: 'flex',
                gap: 8,
                alignItems: 'flex-start',
                padding: '7px 8px 7px 10px',
                cursor: 'pointer',
                border: '1px solid ' + (on ? 'var(--color-accent)' : 'var(--color-neutral-300)'),
                background: on ? 'var(--color-accent-100)' : '#fff',
              }}
            >
              <span style={{ fontFamily: 'var(--font-heading)', fontWeight: 600, fontSize: 13 }}>
                {('0' + (k + 1)).slice(-2)}
              </span>
              <span style={{ fontSize: 10.5, lineHeight: 1.3, flex: 1 }}>{fr.title || 'Untitled frame'}</span>
              <span style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <span
                  onClick={(e) => {
                    e.stopPropagation()
                    onMove(k, -1)
                  }}
                  style={{
                    cursor: 'pointer',
                    fontSize: 9,
                    lineHeight: 1,
                    padding: '2px 3px',
                    border: '1px solid var(--color-neutral-300)',
                    background: '#fff',
                  }}
                >
                  ▲
                </span>
                <span
                  onClick={(e) => {
                    e.stopPropagation()
                    onMove(k, 1)
                  }}
                  style={{
                    cursor: 'pointer',
                    fontSize: 9,
                    lineHeight: 1,
                    padding: '2px 3px',
                    border: '1px solid var(--color-neutral-300)',
                    background: '#fff',
                  }}
                >
                  ▼
                </span>
              </span>
            </div>
          )
        })}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
          padding: 12,
          borderTop: '1px solid var(--color-neutral-200)',
        }}
      >
        <button className="btn btn-secondary" onClick={onDuplicate} style={{ height: 28, fontSize: 10.5, padding: 0 }}>
          Duplicate frame
        </button>
        <button className="btn btn-secondary" onClick={onBlank} style={{ height: 28, fontSize: 10.5, padding: 0 }}>
          Blank frame
        </button>
        <button
          className="btn btn-ghost"
          onClick={onDelete}
          disabled={frames.length <= 1}
          style={{ height: 26, fontSize: 10.5, padding: 0, color: 'var(--color-neutral-600)' }}
        >
          Delete frame
        </button>
      </div>
    </div>
  )
}
